import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import { BlockedByFeature, BlockedByFeatureType } from '../../../featureToggles/features/utils';
import { RootState } from '../../rootReducer';
import { IPromotionalCodeDiscount } from './interfaces';

export const getIsValidatingCode = (state: RootState): boolean | BlockedByFeatureType => {
  if (!isFeatureEnabled(Features.PromotionalCodes)) {
    return BlockedByFeature;
  }
  return state.upgradeAccount.promotionalCode.validating;
};

export const getValidationErrorMessage = (state: RootState): string | undefined | BlockedByFeatureType => {
  if (!isFeatureEnabled(Features.PromotionalCodes)) {
    return BlockedByFeature;
  }
  return state.upgradeAccount.promotionalCode.error;
};

export const getPromotionalCode = (state: RootState): string | undefined | BlockedByFeatureType => {
  if (!isFeatureEnabled(Features.PromotionalCodes)) {
    return BlockedByFeature;
  }
  return state.upgradeAccount.promotionalCode.code;
};

export const getPromotionalDiscount = (state: RootState): IPromotionalCodeDiscount | undefined | BlockedByFeatureType => {
  if (!isFeatureEnabled(Features.PromotionalCodes)) {
    return BlockedByFeature;
  }
  return state.upgradeAccount.promotionalCode.discount;
};